"use client";

import React from "react";
import { Check, Bug, Droplet, Shield, TriangleAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { cn } from "@/lib/utils";
const batches = [{
  title: "مساحة المكان",
  description: "يتم تقدير السعر بناءً على إجمالي المساحة المربعة للمنشأة المراد معالجتها.",
  icon: Bug,
  features: ["معاينة دقيقة للمساحات المفتوحة", "فحص الزوايا والمستودعات", "تغطية كاملة للمباني السكنية", "خصومات للمساحات الكبيرة"],
  isRecommended: false,
  buttonText: "احسب التكلفة",
  link: "/HomePage"
}, {
  title: "حجم الإصابة بالحشرات",
  description: "تحديد كثافة انتشار الحشرات ونوعها لضمان اختيار المبيد المناسب.",
  icon: Droplet,
  features: ["فحص بؤر الانتشار الرئيسية", "تحديد نوع الحشرة بدقة", "خطة مكافحة مكثفة للإصابات", "ضمان عدم عودة الحشرات", "تقارير فنية دورية"],
  isRecommended: true,
  buttonText: "اطلب معاينة فورية",
  link: "/HomePage"
}, {
  title: "نوع المبيدات المستخدمة",
  description: "نقدم خيارات متنوعة من المبيدات الألمانية والأمريكية حسب الحاجة.",
  icon: Shield,
  features: ["مبيدات عديمة الرائحة", "مبيدات آمنة على الأطفال", "تقنيات الرش الضبابي", "مواد معتمدة من الصحة"],
  isRecommended: false,
  buttonText: "عرض أنواع المبيدات",
  link: "/HomePage"
}];
export default function TheMbbsPathwayBatches() {
  return <section data-section-id="233060" id="معايير-تحديد-التكلفة" className="py-20 bg-primary text-white font-default" dir="rtl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            معايير تحديد تكلفة الخدمة
          </h2>
          <p className="text-lg text-white/80 leading-relaxed">
            نعتمد في شركة سرايا على الشفافية التامة في تسعير خدمات مكافحة الحشرات بناءً على معايير فنية دقيقة تضمن لك أفضل قيمة مقابل السعر.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {batches.map((batch, i) => {
          const Icon = batch.icon;
          return <div key={i} data-index={i} className={cn("relative flex flex-col p-8 rounded-lg border transition-all duration-400 group", batch.isRecommended ? "bg-secondary border-accent/30 shadow-xl scale-105 z-10" : "bg-secondary/40 border-white/10 backdrop-blur-md hover:bg-secondary/60")}>
                {batch.isRecommended && <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <Badge className="bg-accent text-primary border-none rounded-full px-6 py-1.5 font-bold text-sm shadow-lg">
                      الأكثر طلباً
                    </Badge>
                  </div>}

                <div className="mb-6">
                  <div className={cn("w-14 h-14 rounded-lg flex items-center justify-center mb-4 transition-colors", batch.isRecommended ? "bg-accent/20" : "bg-white/5")}>
                    <Icon className={cn("w-8 h-8", batch.isRecommended ? "text-accent" : "text-white/70")} />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-3">{batch.title}</h3>
                  <p className="text-white/70 text-sm leading-relaxed min-h-[3rem]">
                    {batch.description}
                  </p>
                </div>

                <div className="flex-grow mb-8">
                  <div className="text-xs font-bold text-white/40 uppercase tracking-wider mb-4">المميزات الفنية</div>
                  <ul className="space-y-3">
                    {batch.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3 text-sm text-white/80">
                        <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" />
                        <span>{feature}</span>
                      </li>)}
                  </ul>
                </div>

                <Button asChild variant={batch.isRecommended ? "default" : "outline"} className={cn("w-full rounded-full font-bold py-6 text-base transition-all duration-200", batch.isRecommended ? "bg-accent text-primary hover:bg-accent/90 hover:scale-[1.02]" : "border-white/20 text-white hover:bg-white/5")}>
                  <Link to={batch.link}>{batch.buttonText}</Link>
                </Button>
              </div>;
        })}
        </div>

        <div className="mt-20 max-w-4xl mx-auto">
          <Alert className="bg-secondary/80 border-accent/20 backdrop-blur-md shadow-2xl rounded-lg p-6">
            <TriangleAlert className="h-6 w-6 text-accent" />
            <AlertTitle className="text-white font-bold text-xl mb-2">
              تنبيه هام لعملائنا الكرام
            </AlertTitle>
            <AlertDescription className="text-white/70 text-base leading-relaxed">
              <strong className="text-accent">احذر من التعامل مع الشركات غير المرخصة!</strong> نحن في سرايا نلتزم بتقديم فواتير ضريبية رسمية وضمان حقيقي معتمد على كافة الخدمات، دون أي رسوم خفية أو إضافات غير معلنة بعد بدء العمل.
            </AlertDescription>
          </Alert>
        </div>
      </div>
    </section>;
}